import { useEffect } from "react";

const ONE_HOUR = 60 * 60 * 1000;

/**
 * Refetches a query when the window regains focus, but only when the last
 * successful fetch (the query's `fulfilledTimeStamp`) is older than
 * `staleTime`. Unlike RTK Query's `refetchOnFocus`, this avoids refetching on
 * every focus change while the data is still fresh.
 */
export function useRefetchOnFocusIfStale(
  refetch: () => void,
  fulfilledTimeStamp: number | undefined,
  staleTime: number = ONE_HOUR,
): void {
  useEffect(() => {
    const onFocus = () => {
      if (
        fulfilledTimeStamp !== undefined &&
        Date.now() - fulfilledTimeStamp > staleTime
      ) {
        refetch();
      }
    };

    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [refetch, fulfilledTimeStamp, staleTime]);
}
